export const APP_URL = 'currency-zone';
